import { render, staticRenderFns } from "./SpcmCalendarCategoryEdit.vue?vue&type=template&id=022ded15"
import script from "./SpcmCalendarCategoryEdit.vue?vue&type=script&lang=js"
export * from "./SpcmCalendarCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports